const MySongDetailAdapter = resp => {
    let result = [];

    if (!(resp && resp.response.components && Array.isArray(resp.response.components))) {
        console.log('La api no contiene componentes');
        return result;
    }

    resp.response.components.forEach(section => {
        if (section.type === 'GRID') {
            result = section.items.map(el => {
                let obj = {};
                obj = {
                    albumId: el.albumId || null,
                    albumName: el.albumName || '',
                    artist: el.artist || '',
                    artistId: el.artistId || null,
                    artists: el.author || null,
                    duration: el.duration || '',
                    id: el.entity_id || null,
                    image: el.img || '',
                    isFavorite: el.isFavorite || false,
                    name: el.name || '',
                    url: el.play_url || '',
                    tracking: el.tracking || null
                };
                return obj;
            });
            console.log('transformApiResponse');
        }
    });
    return result;
};

export default MySongDetailAdapter;


// WEBPACK FOOTER //
// ./src/components/MySongs/MySongDetailAdapter.js